export type DataType = 'files' | 'templates'

export enum FileObjective {
  DATA_DICTIONARY = 'data_dictionary',
  LIST_VALUES = 'list_values',
}

export type FormFile = File & {
  objective: FileObjective
}

export interface TemplateItem {
  id: number
  title: string
  subtitle: string
}

export interface TranslationUploadForm {
  stepOne: {
    dataType: DataType
    templates: TemplateItem[]
    files: FormFile[]
  }
  stepTwo: {
    dataType: DataType
    templates: TemplateItem[]
    files: FormFile[]
  }
}
